import {Component, Injector, OnInit} from "@angular/core";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";
import {TabletMapping} from "@models";
import {NotificationService, SimSystemExtendedService} from "@services";

export interface TABLET_MAPPING_CONFIGURATION_DIALOG_INPUT extends MatDialogDataBaseInput {
	tabletMapping: TabletMapping;
}

export interface TABLET_MAPPING_CONFIGURATION_DIALOG_OUTPUT extends MatDialogDataBaseOutput {
	tabletMapping: TabletMapping;
}

@Component({
	selector: "sim-tablet-mapping-configuration-dialog",
	templateUrl: "./tablet-mapping-configuration-dialog.component.html",
	styleUrls: ["./tablet-mapping-configuration-dialog.component.scss"],
	standalone: false,
})
export class TabletMappingConfigurationDialogComponent
	extends BasicMaterialDialog<
		TabletMappingConfigurationDialogComponent,
		TABLET_MAPPING_CONFIGURATION_DIALOG_INPUT,
		TABLET_MAPPING_CONFIGURATION_DIALOG_OUTPUT
	>
	implements OnInit
{
	hidePassword = true;

	constructor(
		private _simSystemService: SimSystemExtendedService,
		private _simNotificationService: NotificationService,
		_injector: Injector,
	) {
		super(_injector);
	}

	public async findMacAddressForTablet(ip: string) {
		if (!ip) {
			return;
		}
		const macAddressResult = await this._simSystemService.getMacAddress(ip);
		if (macAddressResult) {
			this.data.tabletMapping.macAddress = macAddressResult;
		} else {
			this._simNotificationService.notifyError("Could not find a MAC address for the given IP address.");
		}
	}

	public saveTabletMapping() {
		this.close({action: "ok", tabletMapping: this.data.tabletMapping});
	}
}
